import React, { Component } from 'react';
import { BagsJourneyStatus, BagsJourneyType } from 'src/globals';
// images
const CompletedIcon = require('../../images/status-complete.svg');
const InProgressIcon = require('../../images/status-in-progress.svg');
const PendingIcon = require('../../images/status-pending.svg');
const UrgentAttention = require('../../images/urgentAction.svg');
const CompleteWithWarningIcon = require('../../images/complete-warn.svg');
// styles
const styles = require('./status-list-component.scss');

interface IProps {
  language: string;
  multiLang: any;
  bagsJourney: any;
  completedTrackingStatus: any;
}


const IMAGE_MAP = {
  Pending: PendingIcon,
  InProgress: InProgressIcon,
  Completed: CompletedIcon,
  UrgentAttention: UrgentAttention,
  CompleteWithWarning: CompleteWithWarningIcon,
}

const TITLE_MAP = {
  Collected: 'Bags collected',
  InTransit: 'Bags in transit',
  InStorage: 'Bags placed in storage',
  OutOfStorage: 'Bags collected from storage',
  CheckedIn: 'Bags checked in',
  Downgraded: 'Bags not checked in',
}

const STATUS_MAP = {
  Pending: 'pendingTitle',
  InProgress: 'inProgressTitle',
  Completed: 'completeTitle',
  UrgentAttention: 'Urgent attention',
}

export class StatusList extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  componentDidMount() { }

  getTitle(type, status) {
    if (type === BagsJourneyType[1]) {
      if (status === BagsJourneyStatus[3]) {
        return 'Bags collected';
      } else {
        return 'Collecting bags';
      }
    } else {
      return TITLE_MAP[type]
    }
  }

  render() {
    const { bagsJourney = [], multiLang, language, completedTrackingStatus } = this.props; // multiLang, language,



    return (
      <div className={styles.list}>
        {
          bagsJourney?.map((journeyItem, index) => {

            const title = this.getTitle(BagsJourneyType[journeyItem.bagsJourneyType], BagsJourneyStatus[journeyItem.bagsJourneyStatus])
            const status = STATUS_MAP[BagsJourneyStatus[journeyItem.bagsJourneyStatus]];
            const partialCheckin = journeyItem.bagsJourneyType === BagsJourneyType.CheckedIn && completedTrackingStatus?.totalBagCount !== completedTrackingStatus?.injectBagCount && journeyItem.bagsJourneyStatus === BagsJourneyStatus.Completed;
            const dateCheck = journeyItem?.dateTimeText.match(/today|tomorrow/ig);
            const jobDateTime = dateCheck ? multiLang[dateCheck[0].toLowerCase() + language] + journeyItem.dateTimeText.replace(dateCheck[0], '') : journeyItem.dateTimeText;
            return <>
              <div
                className={styles.list_item}
                key={index}
              >
                <div className={styles.list_item_section}>
                  <img src={IMAGE_MAP[partialCheckin ? 'CompleteWithWarning' : BagsJourneyStatus[journeyItem.bagsJourneyStatus]]} width={40} height={40} />

                  <div>
                    <h3 className={styles.title}>
                      {multiLang[`${title}${language}`] ?? title}
                    </h3>
                    <p className={styles.status} >
                      {multiLang[`${status}${language}`] ?? status} {partialCheckin && `(${completedTrackingStatus.injectBagCount}/${completedTrackingStatus.totalBagCount} ${multiLang['ofBags' + language]})`}
                    </p>
                  </div>
                </div>

                <div>
                  <p className={styles.dateTime} > {jobDateTime}</p>
                </div>
              </div>
              <div className={styles.divider}></div>
            </>
          })
        }</div>
    );
  }
}

export default StatusList;



// WEBPACK FOOTER //
// ./src/components/status-list-component/status-list-component.tsx